function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['security']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8091')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/user_settings';
var DOMAIN_PROFILE = '/profile';
var DOMAIN_ROLES_DESCRIPTION = '/roles_desc';
var DOMAIN_NOTIFICATIONS = '/notifications';
export default {
  getProfile: function getProfile(email) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = {
      login: login,
      data: data
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILE, "/").concat(email), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  updateProfile: function updateProfile(email, user) {
    var login = loginObj();
    var body = {
      login: login,
      user: user
    };
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILE, "/").concat(email), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  getRolesDescription: function getRolesDescription() {
    var lang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';
    var login = loginObj();
    var headers = {
      headers: {
        'Accept-Language': lang
      }
    };
    var body = {
      login: login
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ROLES_DESCRIPTION, "/get_all"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  getUserNotifications: function getUserNotifications(email) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILE, "/").concat(email).concat(DOMAIN_NOTIFICATIONS, "/get_all"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  updateNotification: function updateNotification(email, notificationId) {
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.put("".concat(CONTROLLER_NAME).concat(DOMAIN_PROFILE, "/").concat(email).concat(DOMAIN_NOTIFICATIONS, "/").concat(notificationId), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  get_last_searchs: function get_last_searchs(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/get_last_searchs"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  save_search: function save_search(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/save_search"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  },
  delete_search: function delete_search(data) {
    var login = loginObj();
    var body = _objectSpread({
      login: login
    }, data);
    return appApisGTW.post("".concat(CONTROLLER_NAME, "/delete_search"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    }).catch(function (err) {
      console.error(err);
    });
  }
};